import styled, { css } from 'styled-components'
import { StrictRequired } from 'src/shared/types/typescript-utils/strict-required'
import { CarouselInterface } from 'src/shared/entities/carousel/carousel.schema'

type CarouselArrowLeftUiProps = StrictRequired<
  Pick<CarouselInterface, 'showArrows' | 'mobileShowArrows'>
>

const CarouselArrowLeftUi = styled.i<CarouselArrowLeftUiProps>`
  display: ${p => (p.showArrows ? 'block' : 'none')};
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      display: ${p.mobileShowArrows ? 'block' : 'none'};
    `};
  ${p => p.theme.phone} {
    display: ${p => (p.mobileShowArrows ? 'block' : 'none')};
  }
  color: ${p => p.color};
  position: absolute;
  left: 10px;
  top: 50%;
  padding: 10px;
  font-size: 20px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;
`

export default CarouselArrowLeftUi
